import React, { useState } from 'react';
import { Button, Modal, Row, Col } from 'react-bootstrap/';
import InputColor from 'react-input-color';
import PropTypes from 'prop-types';
import { Switch } from 'pretty-checkbox-react';
import AlertMsg from '../../components/AlertMsg';

import { useSelector, useDispatch } from 'react-redux';
import { editDashboards } from '../../redux/actions/dashboards';
import { getAllDevices } from '../../redux/actions/devices';

import tableFontSizes from '../../config-panel-dash/tableFontSizes';

function ModalEditQueuesDash (props) {
  const initialConfig = {
    limit1Color: '#000',
    limit1Value: 0,
    limit2Color: '#000',
    limit2Value: 0,
    limit3Color: '#000',
    limit3Value: 0
  };
  const initialData = {
    name: '',
    fontSizeQueue: '50',
    fontSizeInitials: '50',
    fontSizeNumber: '50',
    fontSizeName: '50',
    showInitials: true,
    showNumber: true,
    showName: true,
    configFields: []
  };
  const dispatch = useDispatch();
  const dashboards = useSelector(state => state.dashboards);
  const groups = useSelector(state =>
    state.devices.data
      .filter(device => device.type === 'G')
      .sort((a, b) => {
        if (a.number && b.number) {
          return String(a.number).localeCompare(String(b.number), undefined, {
            numeric: true,
            sensitivity: 'base'
          });
        } else {
          return 0;
        }
      })
  );
  const { showEditQueue, setShowEditQueue, currentDash, editingPanel } = props;
  const handleClose = () => setShowEditQueue(false);
  const handleCloseConfig = () => setShowConfig(false);
  const onExited = () => {
    setShowConfig(false);
    setData({ ...initialData });
  };
  const onEnter = () => {
    setData({ ...data, ...editingPanel });
    setEditingGroup('');
    setConfig({ ...initialConfig });
    setErrorLimitConfig(false);
    dispatch(getAllDevices());
  };
  const [showConfig, setShowConfig] = useState(false);
  const [config, setConfig] = useState({ ...initialConfig });
  const [data, setData] = useState({ ...initialData });
  const [copySucess, setCopySucess] = useState(false);
  const [pasteSucess, setPasteSucess] = useState(false);
  const [errorLimitConfig, setErrorLimitConfig] = useState(false);
  const [editingGroup, setEditingGroup] = useState('');

  const handleClickSaveConfigGlobal = () => {
    const dash = {
      ...currentDash,
      items: currentDash.items.map(item =>
        item.i !== data.i ? { ...item } : { ...data }
      )
    };
    dispatch(editDashboards(dash));
  };

  const handleClickSaveConfigLimit = () => {
    const id = editingGroup;
    const configFields = data.configFields.filter(
      config => Object.keys(config)[0] !== id
    );
    const l1 = String(config.limit1Value).replace(/:|_/g, '');
    const l2 = String(config.limit2Value).replace(/:|_/g, '');
    const l3 = String(config.limit3Value).replace(/:|_/g, '');
    const conf = {
      ...config,
      limit1Value: l1 ? parseInt(l1) : 0,
      limit2Value: l2 ? parseInt(l2) : 0,
      limit3Value: l3 ? parseInt(l3) : 0
    };
    if (
      !!l1 &&
      !!l2 &&
      !!l3 &&
      ((conf.limit1Value === 0 &&
        conf.limit2Value === 0 &&
        conf.limit3Value === 0) ||
        (conf.limit1Value !== conf.limit2Value &&
          conf.limit2Value !== conf.limit3Value &&
          conf.limit3Value !== conf.limit1Value))
    ) {
      const dash = {
        ...currentDash,
        items: currentDash.items.map(item =>
          item.i !== data.i
            ? { ...item }
            : {
              ...data,
              configFields: configFields.concat([{ [id]: conf }])
            }
        )
      };
      setErrorLimitConfig(false);
      dispatch(editDashboards(dash));
    } else {
      setErrorLimitConfig(true);
    }
  };

  const handleChangeCheckOption = evt => {
    setData({
      ...data,
      [evt.target.name]: evt.target.checked
    });
  };

  const handleChangeGroup = evt => {
    const { value } = evt.target;
    setEditingGroup(value);
    if (!value.length) {
      setConfig({ ...initialConfig });
    } else {
      const id = value;
      const configField = data.configFields.find(config =>
        Object.keys(config).includes(id)
      );
      if (configField) {
        setConfig({ ...initialConfig, ...configField[id] });
      } else {
        setConfig({ ...initialConfig });
      }
    }
  };

  const handleChange = evt => {
    evt.preventDefault();
    if (evt.target.getAttribute('number') === 'on') {
      if (evt.target.value.match(/^\d+$/) || evt.target.value === '') {
        setData({
          ...data,
          [evt.target.name]: evt.target.value
        });
      } else {
        evt.target.value = data[evt.target.name];
      }
    } else {
      const isCheckbox = evt.target.type === 'checkbox';
      setData({
        ...data,
        [evt.target.name]: isCheckbox ? evt.target.checked : evt.target.value
      });
    }
  };

  const handleChangeColor = (color, field) => {
    const { r, g, b, a, hex } = color;
    if (
      editingGroup.length &&
      !isNaN(r) &&
      !isNaN(g) &&
      !isNaN(b) &&
      !isNaN(a) &&
      (hex.length === 4 || hex.length === 7)
    ) {
      setConfig({ ...config, [field]: hex });
    }
  };

  const handleChangeLimit = evt => {
    evt.preventDefault();
    if (evt.target.value === '') {
      setConfig({
        ...config,
        [evt.target.name]: evt.target.value
      });
    } else if (evt.target.value.match(/^\d+$/)) {
      const value = parseInt(evt.target.value, 10);
      setConfig({
        ...config,
        [evt.target.name]: value > -1 ? value : 0
      });
    } else {
      evt.target.value = config[evt.target.name];
    }
  };

  const handleClickConfigDefault = () => {
    setConfig({ ...initialConfig });
  };

  const handleClickCopyConfig = () => {
    localStorage.setItem('config', JSON.stringify(config));
    localStorage.setItem('copyedField', editingGroup);
    setCopySucess(true);
    setTimeout(() => {
      setCopySucess(false);
    }, 1600);
  };

  const handleClickPasteConfig = () => {
    try {
      const conf = JSON.parse(localStorage.getItem('config'));
      setConfig({ ...conf });
      setPasteSucess(true);
      setTimeout(() => {
        setPasteSucess(false);
      }, 1600);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <Modal
        show={showEditQueue}
        onEnter={onEnter}
        onHide={() => setShowEditQueue(false)}
        onExited={onExited}
        dialogClassName="modal-auto-width"
      >
        <Modal.Body className="modal-body-responsive pb-1">
          {dashboards.editSuccess && (
            <AlertMsg type="success" msg="Fila atualizada com sucesso" />
          )}
          {dashboards.editError && (
            <AlertMsg
              type="danger"
              msg="Falha durante atualização do gráfico"
            />
          )}
          {!dashboards.editSuccess && !dashboards.editError && (
            <AlertMsg type="info" msg="Área configuração de fila" />
          )}
          <h3 className="mb-2 ml-2">
            {editingPanel && editingPanel.type}:{' '}
            <span className="badge badge-dark">
              {editingPanel && editingPanel.name}
            </span>
          </h3>
          {!showConfig && (
            <div className="container-fluid pr-2 pl-2">
              <div className="form-group form-inline mb-2">
                <label htmlFor="name" className="w-100 d-inline-block">
                  Nome do Painel
                </label>
                <input
                  type="text"
                  id="name"
                  className="form-control col mr-3"
                  name="name"
                  autoComplete="off"
                  value={data.name}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="btn btn-info"
                  onClick={() => setShowConfig(true)}
                >
                  <i className="fa fa-cog" />
                  &nbsp;Alertas
                </button>
              </div>
              <div className="form-group mb-2">
                <label className="m-0">Configurar Tamanho da Fonte</label>
                <div className="p-2 border">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="fontSizeName">
                          Fonte Nome do Grupo
                        </label>
                        <select
                          className="form-control"
                          id="fontSizeName"
                          name="fontSizeName"
                          value={data.fontSizeName}
                          onChange={handleChange}
                        >
                          {tableFontSizes.map(fontSize => (
                            <option key={fontSize} value={fontSize}>
                              {fontSize}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="fontSizeNumber">
                          Fonte Número do Grupo
                        </label>
                        <select
                          className="form-control"
                          id="fontSizeNumber"
                          name="fontSizeNumber"
                          value={data.fontSizeNumber}
                          onChange={handleChange}
                        >
                          {tableFontSizes.map(fontSize => (
                            <option key={fontSize} value={fontSize}>
                              {fontSize}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="fontSizeQueue">
                          Fonte Fila do Grupo
                        </label>
                        <select
                          className="form-control"
                          id="fontSizeQueue"
                          name="fontSizeQueue"
                          value={data.fontSizeQueue}
                          onChange={handleChange}
                        >
                          {tableFontSizes.map(fontSize => (
                            <option key={fontSize} value={fontSize}>
                              {fontSize}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="fontSizeInitials">
                          Fonte Sigla do Grupo
                        </label>
                        <select
                          className="form-control"
                          id="fontSizeInitials"
                          name="fontSizeInitials"
                          value={data.fontSizeInitials}
                          onChange={handleChange}
                        >
                          {tableFontSizes.map(fontSize => (
                            <option key={fontSize} value={fontSize}>
                              {fontSize}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group mb-4">
                <label className="m-0">Mostrar no Dashboard</label>
                <div className="p-0 border">
                  <div className="row p-2">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="showInitials">Sigla do Grupo</label>
                        <div className="checkbox">
                          <Switch
                            type="checkbox"
                            color="success"
                            id="showInitials"
                            name="showInitials"
                            onChange={handleChangeCheckOption}
                            checked={data.showInitials}
                          >
                            {data.showInitials ? 'Ativado' : 'Desativado'}
                          </Switch>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="showName">Nome do Grupo</label>
                        <div className="checkbox">
                          <Switch
                            type="checkbox"
                            color="success"
                            id="showName"
                            name="showName"
                            onChange={handleChangeCheckOption}
                            checked={data.showName}
                          >
                            {data.showName ? 'Ativado' : 'Desativado'}
                          </Switch>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4 pr-0">
                      <div className="form-group">
                        <label htmlFor="showNumber">Número do Grupo</label>
                        <div className="checkbox">
                          <Switch
                            type="checkbox"
                            color="success"
                            id="showNumber"
                            name="showNumber"
                            onChange={handleChangeCheckOption}
                            checked={data.showNumber}
                          >
                            {data.showNumber ? 'Ativado' : 'Desativado'}
                          </Switch>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showConfig && (
            <div className="container-fluid pr-2 pl-2">
              <div className="form-group">
                <label htmlFor="group">Selecione o Grupo</label>
                <select
                  className="form-control"
                  id="group"
                  name="group"
                  value={editingGroup}
                  onChange={handleChangeGroup}
                >
                  <option value="">-- Selecione --</option>
                  {groups.map(grp => (
                    <option key={grp._id} value={grp._id}>
                      {`${grp.number} | ${grp.name} - Dpto: ${grp.department.name}`}
                    </option>
                  ))}
                </select>
              </div>
              <Row>
                <Col sm={12} md={12} lg={12}>
                  <div>
                    <Row>
                      <Col xs={6}>
                        <label>Limite 1</label>
                        <div className="input-group">
                          <input
                            type="text"
                            name="limit1Value"
                            className="form-control limit"
                            onChange={handleChangeLimit}
                            autoComplete="off"
                            value={
                              !config.limit1Value ||
                              parseInt(config.limit1Value) > -1
                                ? config.limit1Value
                                : 0
                            }
                            disabled={!editingGroup.length}
                          />
                        </div>
                      </Col>
                      <Col xs={6}>
                        <label>Cor 1</label>
                        <Row>
                          <Col sm={3} xs={4}>
                            <div>
                              {editingGroup.length ? (
                                <InputColor
                                  name="limit1Color"
                                  className="picker-color"
                                  initialHexColor={config.limit1Color}
                                  onChange={color =>
                                    handleChangeColor(color, 'limit1Color')
                                  }
                                  placement="bottom"
                                />
                              ) : (
                                <span className="mock-input-color">
                                  <span></span>
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col sm={9} xs={8}>
                            <input
                              type="text"
                              className="form-control limit"
                              value={
                                config.limit1Color.length > 4
                                  ? config.limit1Color
                                  : ''
                              }
                              readOnly={true}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={6}>
                        <label>Limite 2</label>
                        <div className="input-group">
                          <input
                            type="text"
                            name="limit2Value"
                            className="form-control limit"
                            onChange={handleChangeLimit}
                            autoComplete="off"
                            value={
                              !config.limit2Value ||
                              parseInt(config.limit2Value) > -1
                                ? config.limit2Value
                                : 0
                            }
                            disabled={!editingGroup.length}
                          />
                        </div>
                      </Col>
                      <Col xs={6}>
                        <label>Cor 2</label>
                        <Row>
                          <Col sm={3} xs={4}>
                            <div>
                              {editingGroup.length ? (
                                <InputColor
                                  name="limit2Color"
                                  className="picker-color"
                                  initialHexColor={config.limit2Color}
                                  onChange={color =>
                                    handleChangeColor(color, 'limit2Color')
                                  }
                                  placement="bottom"
                                />
                              ) : (
                                <span className="mock-input-color">
                                  <span></span>
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col sm={9} xs={8}>
                            <input
                              type="text"
                              className="form-control limit"
                              value={
                                config.limit2Color.length > 4
                                  ? config.limit2Color
                                  : ''
                              }
                              readOnly={true}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={6}>
                        <label>Limite 3</label>
                        <div className="input-group">
                          <input
                            type="text"
                            name="limit3Value"
                            className="form-control limit"
                            onChange={handleChangeLimit}
                            autoComplete="off"
                            value={
                              !config.limit3Value ||
                              parseInt(config.limit3Value) > -1
                                ? config.limit3Value
                                : 0
                            }
                            disabled={!editingGroup.length}
                          />
                        </div>
                      </Col>
                      <Col xs={6}>
                        <label>Cor 3</label>
                        <Row>
                          <Col sm={3} xs={4}>
                            <div>
                              {editingGroup.length ? (
                                <InputColor
                                  name="limit3Color"
                                  className="picker-color"
                                  initialHexColor={config.limit3Color}
                                  onChange={color =>
                                    handleChangeColor(color, 'limit3Color')
                                  }
                                  placement="bottom"
                                />
                              ) : (
                                <span className="mock-input-color">
                                  <span></span>
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col sm={9} xs={8}>
                            <input
                              type="text"
                              className="form-control limit"
                              value={
                                config.limit3Color.length > 4
                                  ? config.limit3Color
                                  : ''
                              }
                              readOnly={true}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  <Row className="pt-2 pb-2 text-center">
                    <Col>
                      <Button
                        variant="dark"
                        onClick={handleClickCopyConfig}
                        style={{ cursor: 'copy' }}
                        disabled={!editingGroup.length}
                      >
                        <i className="fas fa-copy" />
                        <p className="m-0">Copiar</p>
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        variant="info"
                        onClick={handleClickConfigDefault}
                        disabled={!editingGroup.length}
                      >
                        <i className="fas fa-undo" />
                        <p className="m-0">Padrão</p>
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        variant="dark"
                        onClick={handleClickPasteConfig}
                        disabled={
                          !editingGroup.length ||
                          !localStorage.getItem('config') ||
                          localStorage.getItem('copyedField') === editingGroup
                        }
                        style={{ cursor: 'context-menu' }}
                      >
                        <i className="fas fa-paste" />
                        <p className="m-0">&nbsp;Colar&nbsp;</p>
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {showConfig && copySucess && (
                <p className="text-center m-0">
                  <small className="text-success font-weight-bold">
                    Configuração copiada para área de transferência
                  </small>
                </p>
              )}
              {showConfig && pasteSucess && (
                <p className="text-center m-0">
                  <small className="text-success font-weight-bold">
                    Configuração copiada com sucesso
                  </small>
                </p>
              )}
              {showConfig && errorLimitConfig && (
                <p className="text-center m-0">
                  <small className="text-danger font-weight-bold">
                    Configure cada limite corretamente
                  </small>
                </p>
              )}
              {showConfig && !copySucess && !pasteSucess && !errorLimitConfig && (
                <p className="text-center m-0">
                  <small>&nbsp;</small>
                </p>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={showConfig ? handleCloseConfig : handleClose}
          >
            {showConfig && (
              <span>
                <i className="fas fa-arrow-left" /> Voltar
              </span>
            )}
            {!showConfig && (
              <span>
                <i className="fas fa-times" /> Fechar
              </span>
            )}
          </button>
          {!showConfig && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleClickSaveConfigGlobal}
              disabled={dashboards.isFetching || !data.name.trim().length}
            >
              <span>
                <i className="fas fa-save" /> Salvar
              </span>
            </button>
          )}
          {showConfig && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleClickSaveConfigLimit}
              disabled={
                dashboards.isFetching ||
                !data.name.trim().length ||
                !editingGroup.length
              }
            >
              <span>
                <i className="fas fa-save" /> Salvar
              </span>
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

ModalEditQueuesDash.propTypes = {
  showEditQueue: PropTypes.bool,
  setShowEditQueue: PropTypes.func,
  currentDash: PropTypes.object,
  editingPanel: PropTypes.object
};

export default ModalEditQueuesDash;
